import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
// import $ from 'jquery's
import Storage from "./assets/js/storage.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Base64 } from "js-base64";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import VueTouch from "vue-touch";
import "default-passive-events";
import md5 from "./assets/js/md5.min";
import VConsole from "./assets/js/vconsole.min";
import { encrypt, decrypt } from "../admin/assets/js/encryp";

Vue.use(ElementUI, axios);
Vue.use(preview);
Vue.use(VueTouch, { name: "v-touch" });
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$qiniuUrl = "http://resource.wangpeishi.org.cn/";
Vue.prototype.$price = "2500元";
Vue.prototype.Storage = Storage;
Vue.prototype.$md5 = md5;
Vue.prototype.$VConsole = VConsole;
Vue.prototype.$encrypt = encrypt;
Vue.prototype.$decrypt = decrypt;
Vue.prototype.$Base64 = Base64;
axios.interceptors.request.use(
    config => {
        // console.log(window.location.href.indexOf('/ks')!=-1);
        let token = Storage.getStorage("token");
        if (config.url.indexOf("admin") != -1) {
            token = Storage.getStorage("adminToken");
        }
        if (window.location.href.indexOf("/ks") != -1) {
            token = Storage.getStorage("ksToken");
        }
        if (token) {
            config.headers.Authorization = "Bearer " + token;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            if (error.response.status == 401) {
                localStorage.clear();
                setTimeout(function() {
                    location.href = "/#/login";
                }, 2000);
            }
        }
        // return Promise.reject(error.response.data)
    }
);
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

router.afterEach(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});

new Vue({
    router,
    store,
    render: h => h(App)
    // mounted () {
    //   document.dispatchEvent(new Event('render-event'))
    // }
}).$mount("#app");
